const downlineProfileTestIDs = {
  profileCoachValue: 'profile-coach-value',
  profileIdValue: 'profile-id-value',
  profileSectionHeader: 'profile-section-header',
  profileSectionlink: 'profile-section-link',
  rank: 'rank',
  commissionableVolumeTotal: 'commissionable-volume-total',
  nextPremierOrder: 'premier-order',
  rewards: 'rewards',
  viewMoreButton: 'view-more-button',

  currentFrontlineVolume: 'current-frontline-volume',
  currentGen0Volume: 'current-gen-0-volume',
  currentTotalGenVolume: 'current-total-gen-volume',
  currentMonthToDateVolume: 'current-month-to-date-volume',
  projectedPremierVolume: 'projected-premier-volume',
  projectedTotalGenVolume: 'projected-total-gen-volume',
  newFrontlineClients: 'new-frontline-clients',
  newGen0Clients: 'new-gen-0-clients',
  frontlineReactivatedClients: 'frontline-reactivated-clients',
  gen0ReactivatedClients: 'gen0-reactivated-clients',
  newOrganizationClients: 'new-organization-clients',
  newFrontlineCoaches: 'new-frontline-coaches',
  newGen0Coaches: 'new-gen-0-coaches',
  newOrganizationCoaches: 'new-organization-coaches',
  orderingEntities: 'ordering-entities',
  qualifyingPoints: 'qualifying-points',
  alertView: 'profile-alert-view',
  alertTitle: 'profile-alert-title',
  alertDescription: 'profile-alert-description',
  alertDismissButton: 'profile-alert-dismiss-button',
  alertDismissedMessage: 'profile-alert-dissmissed-message',
  alertUndoDismissButton: 'profile-alert-undo-button',
  alertRemovedMessage: 'profile-alert-removed-message',

  // Client Jounrey
  cjtaskItem: 'cj-task-item',
  checkBox: 'checkbox-',
  cjtaskItemLabel: 'cj-task-item-label',
  cjTitle: 'cj-title',
  cjShowButton: 'cj-show-button',
  cjHideButton: 'cj-hide-button',
  cjTaskKickOfCallDescription: 'cj-first-week-task-kickoff-call-description',
  cjWeeklyCheckinsDescription: 'cj-weekly-checkins-description',
  cjFirstWeekNoOrderLabel:
    'cj-first-week-task-available-after-first-order-label',
  cjTaskKickOfCallCheckbox: 'cj-first-week-task-kickoff-call-checkbox',
  cjTaskCelebrationDescription: 'cj-first-week-task-celebration-description',
  // Task details
  cjTaskDetailsText: 'cj-task-details-text',
  cjTaskDetailsImage: 'cj-task-details-image',
  cjTaskDetailsSecondText: 'cj-task-details-second-text',
  cjTaskDetailsLink: 'cj-task-details-link',
  cjTaskDetailsBulletsHeaderText: 'cj-task-details-bullet-header-text',
  cjTaskDetailBulletView: 'cj-task-details-bullet-view-',
  cjTaskDetailBullet: 'cj-task-details-bullet',
  cjTaskDetailName: 'cj-task-details-name',
  cjTaskDetailMarskTaskCompleteButtonView:
    'cj-task-details-mark-complete-button-view',
  cjTaskDetailMarskTaskCompleteButton: 'cj-task-details-mark-complete-button',

  // First Order
  cjFirstOrderView: 'cj-first-order-view',
  cjFirstOrderTitleLabel: 'cj-first-order-title-label',
  cjFirstOrderStatusLabel: 'cj-first-order-status-label',
  cjFirstOrderNoOrdersLabel: 'cj-first-order-no-orders-label',
  cjFirstOrderStatusIcon: 'cj-first-order-status-icon',
  cjFirstOrderTo: 'cj-first-order-touchable-opacity',
  cjFirstOrderArrivalDateLabel: 'cj-first-order-arrival-date-label',
  cjFirstOrderArrivalDateValue: 'cj-first-order-arrival-date-value',
  cjFirstOrderTrackingNumberLabel: 'cj-first-order-tracking-number-label',
  cjFirstOrderTrackingNumberButton: 'cj-first-order-tracking-number-button',
  cjFirstOrderTrackingNumber: 'cj-first-order-tracking-number',
  cjFirstOrderPackagesCount: 'cj-first-order-packages-count',
  cjFirstOrderPackageStatus: 'cj-first-order-package-status',

  // Candidate profile
  candidateNotesInput: 'ca-notes-input',
  candidateLinkDetail: 'ca-link-detail',
  candidateSource: 'ca-source',
  candidateName: 'ca-name',
  candidateProfileContactHeader: 'ca-profile-contact-header',
  candidateProfileLinksHeader: 'ca-profile-links-header',
  candidateNotesLastChange: 'ca-notes-last-change-label',
  candidateProfileDeleteButton: 'ca-delete-candidate-profile',
  // Candidates edit notes
  candidateNotesEditInput: 'ca-edit-notes-input',
  candidateNotesEditLastChange: 'ca-edit-notes-last-change-label',
  candidateNotesEditCharsCount: 'ca-edit-notes-chars-count-label',
  // Add candidate
  candidateAddLinkButton: 'ca-add-link-button',
  candidateAddAnotherLinkButton: 'ca-add-another-link-button',
  candidateLinksModal: 'ca-add-links-modal',
  candidateLinksModalHeader: 'ca-add-links-modal-header',
  candidateLinksModalCancelButton: 'ca-add-links-modal-cancel-button',
  candidateLinksBoxAddLinkTo: 'ca-add-links-box-add-link-',
  candidateAddlinksError: 'ca-add-links-error',
  candidateLinksBoxAddlinksSubHeader: 'ca-add-links-box-sub-header',
  candidateAddlinksBox: 'ca-add-links-box-',
  candidateAddlinksBoxLinkInput: 'ca-add-links-input',
  // Delete profile confirmation modal
  candidateDeleteModal: 'ca-delete-profile-modal',
  candidateDeleteModalHeader: 'ca-delete-profile-modal-header',
  candidateDeleteModalBody: 'ca-delete-profile-modal-body',
  candidateDeleteModalDeleteButton: 'ca-delete-profile-modal-delete-button',
  candidateDeleteModalCancelButton: 'ca-delete-profile-modal-cancel-button',
  // Merge banner
  mergeBannerRoot: 'merge-banner-root',
  mergeBannerHeader: 'merge-banner-header',
  mergeBannerDescription: 'merge-banner-description',
  mergeBannerIcon: 'merge-banner-icon',
  mergeBannerArrowButton: 'merge-banner-arrow-button',
  mergeBannerName: 'merge-banner-name',
  mergeBannerEmail: 'merge-banner-email',
  mergeBannerMoveToClientButton: 'merge-banner-move-to-client-button',
  mergeBannerArchive: 'merge-banner-archive-button',
  mergeBannerArchiveIcon: 'merge-banner-delete-icon',
  // Merge screens
  mergeScreen: 'merge-screen',
  mergeScreenSecond: 'merge-screen-second',
  mergeScreenDescription: 'merge-screen-description',
  mergeScreenWarningIcon: 'merge-screen-warning-icon',
  mergeScreenPhoneTile: 'merge-screen-phone-tile',
  mergeScreenPhoneLabel: 'merge-screen-phone-label',
  mergeScreenPhoneValue: 'merge-screen-phone-value',
  mergeScreenPhoneAddToNotesLabel: 'merge-screen-phone-add-to-notes-label',
  mergeScreenNext: 'merge-screen-next-button',
  mergeScreenMergeButton: 'merge-screen-second-merge-button',
  mergeScreenSecondDescription: 'merge-screen-second-description',
  mergeConfirm: 'merge-profile-confirmation-popup',
  mergeConfirmHeader: 'merge-profile-confirmation-popup-header',
  mergeConfirmMergeProfilesButton: 'merge-profile-confirmation-popup-confirm',
  mergeConfirmCancelButton: 'merge-profile-confirmation-popup-cancel',

  profileSectionLinksLabel: 'profile-section-links-label',
  profileSectionTile: 'profile-section-tile',
  profileSectionUrlIcon: 'profile-section-url-icon',
  profileSectionUrlType: 'profile-section-url-type',
  profileSectionUrlValue: 'profile-section-url-value',

  profileNotesSection: 'profile-notes-section',
  profileNotesSectionNotesLabel: 'profile-notes-section-notes-label',
  profileNotesSectionNotesInput: 'profile-notes-section-notes-input',
  profileNotesSectionFooterLabel: 'profile-notes-section-notes-footer-label',

  dispositionOptionsHeader: 'ca-disposition-options-header',
  dispositionOptionsSave: 'ca-disposition-options-save-btn',
  profileDisposition: 'profile-current-disposition',
};

export default downlineProfileTestIDs;
